import { useQuery, useMutation } from '@tanstack/react-query'
import { ADD_CHANNEL_PARTNETS_USER, GET_CHANNEL_PARTNERS_UPLOAD_DATES, DELETE_CHANNEL_PARTNETS_USER, EDIT_CHANNEL_PARTNERS_USER, GET_CHANNEL_PARTNERS_USERS_BY_USERID, GET_CHANNEL_PARTNERS_USERLIST_ON_FILTER,
  DELETE_USER_CHANNEL_PARTNER_USERLIST
 } from '../../services/URLs'
import { generatePath } from 'react-router-dom'
import useRequest from '../useRequest'

const MUTATIONS = {
  CHANNEL_PARTNETS_USER_ADD: 'ADD_CHANNEL_PARTNETS_USER', 
  CHANNEL_PARTNERS_USER_DELETE: 'CHANNEL_PARTNERS_USER_DELETE',
  CHANNEL_PARTNERS_USER_EDIT: 'CP_ADMIN_USER_EDIT',
  DELETE_USER_CHANNEL_PARTNER_USERLIST:'DELETE_USER_CHANNEL_PARTNER_USERLIST'
}

const QUERIES = {
  GET_CHANNEL_PARTNERS_UPLOAD_DATES: 'GET_CHANNEL_PARTNERS_UPLOAD_DATES',
  GET_CHANNEL_PARTNERS_USERS_BY_USERID:'GET_CHANNEL_PARTNERS_USERS_BY_USERID',
  GET_CHANNEL_PARTNERS_USERLIST: 'GET_CHANNEL_PARTNERS_USERLIST'
}

interface CPAddUserPayload {
  companyId: string;
  company:string;
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  phone: string;
  fax: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  tempPassword: boolean;
  cpAdmin: boolean;
  uploadInventory: boolean;
  enterOrders: boolean;
  dashboard: boolean;
  viewPriceLists: boolean;
  forecast: boolean;
  forecastEmail: boolean;
}

interface CPUserByUserIdPayload {
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  phone: string;
  fax: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  tempPassword: boolean;
  cpAdmin: boolean;
  uploadInventory: boolean;
  enterOrders: boolean;
  dashboard: boolean;
  viewPriceLists: boolean;
  forecast: boolean;
  forecastEmail: boolean;
}



interface CPUpdateUserPayloadWithId extends CPUserByUserIdPayload {
  userId: string;
}

export const useCPAddUser = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.CHANNEL_PARTNETS_USER_ADD],
      mutationFn: async (payload: CPAddUserPayload) => {
        return await request({
          method: 'post',
          url: ADD_CHANNEL_PARTNETS_USER,
          payload,
          config: { headers: {} },
          completeResponse: true,
        });
      },
  });
}

export const useGetCPUploadDate = () => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.GET_CHANNEL_PARTNERS_UPLOAD_DATES],
    queryFn: async () => {
      return await request({
        method: 'get',
        url: GET_CHANNEL_PARTNERS_UPLOAD_DATES,
        config: {},
        completeResponse: false,
      })
    },
  })
}

export const useDeleteManageCPUser = () => {
  const request = useRequest();
  
  return useMutation({
    mutationKey: [MUTATIONS.CHANNEL_PARTNERS_USER_DELETE],
    mutationFn: async ({ userId }: { userId: string }) => {
      return await request({
        method: 'delete',
        url: generatePath(DELETE_CHANNEL_PARTNETS_USER, { userId: userId }),
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
}

export const useUpdateCPUser = () => {
  const request = useRequest();
  
  return useMutation({
    mutationKey: [MUTATIONS.CHANNEL_PARTNERS_USER_EDIT],
    mutationFn: async (payload: CPUpdateUserPayloadWithId) => {
      return await request({
        method: 'put',
        url: generatePath(EDIT_CHANNEL_PARTNERS_USER, { userId: payload.userId }),
        payload,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
}

export const useGetChannelPartnersUsersByUserId = (id: string | undefined, page: number, size: number) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_CHANNEL_PARTNERS_USERS_BY_USERID],
    queryFn: async () => {
      if (!id) {
        return {}
      }
      return await request({
        method: 'get',
        url: generatePath(GET_CHANNEL_PARTNERS_USERS_BY_USERID, { userId: id }) + `?page=${page}&size=${size}`,
        config: {},
        completeResponse: false,
      })
    },
  })
}

export const useGetChannelPartnersUsersList = (
  activeRole?: [string, boolean]
) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_CHANNEL_PARTNERS_USERLIST, activeRole?.[0]],
    queryFn: async () => {
      let url = generatePath(GET_CHANNEL_PARTNERS_USERLIST_ON_FILTER);

      if (activeRole) {
        const [key] = activeRole;
        url += `?${key}=true`;
      }

      return await request({
        method: 'get',
        url,
        config: {},
        completeResponse: false,
      });
    },
  });
};

export const useDeleteUserFromChannelPartnersUserList = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.DELETE_USER_CHANNEL_PARTNER_USERLIST],
    mutationFn: async ({ userId }: { userId: string }) => {
      return await request({
        method: 'delete',
        url: generatePath(DELETE_USER_CHANNEL_PARTNER_USERLIST, { userId: userId }),
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
}
